import api from '@/plugins/api';
import { checkError, cloneDeep, isNullOrEmpty, prepareApiParams } from 'erp-skeleton-library/utils';

const template = {
  id: 0,
  name: null,
  order: null,
}

const state = {
  tableLoading: false,
  allPraTasks: [],
  registerPraTask: {
    id: 0,
    name: null,
    order: null,
  },
  headers: [
    {
      text: 'Nome',
      align: 'left',
      value: 'name',
      sortable: false,
    },
  ],
};

const mutations = {
  LIST(state, payload) {
    state.allPraTasks = payload;
    state.tableLoading = false;
  },
  SET(state, payload) {
    if (!isNullOrEmpty(payload.risks)) {
      payload?.risks?.forEach(risk => risk.children = cloneDeep(risk.preventions));
      payload.children = cloneDeep(payload.risks);
      state.allPraTasks.push(payload);
    }
  },
  SET_REGISTER(state, payload) {
    if (payload === undefined) {
      state.registerPraTask = cloneDeep(template);
    } else {
      state.registerPraTask = cloneDeep(payload);
    }
  },
  CLEAR() {
    state.allPraTasks = [];
  },
};

const actions = {
  create({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post('pra/tasks', payload)
         .then(response => {
           resolve(response.data);
         }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  list({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let query = prepareApiParams(payload, 'id,name,order');
      state.tableLoading = true;

      api.get('pra/tasks?' + new URLSearchParams(query).toString())
         .then(response => {
           commit('LIST', response.data.entities);
           resolve(response.data);
         })
         .catch(error => {
           checkError(error.response.status);
           reject(error.response);
         });
    });
  },
  read({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.get('pra/tasks/' + id)
         .then(response => {
           commit('SET', response.data);
           commit('SET_REGISTER', response.data);
           resolve(response.data);
         }).catch(error => {
           console.log(error);
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  update({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.put('pra/tasks/' + payload.id, payload)
         .then(response => {
           resolve(response.data);
         }).catch(error => {
        checkError(error.response.status);
        reject(error.response);
      });
    });
  },
  delete({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.delete('pra/tasks/' + id)
         .then((response) => {
           resolve(response.data);
         })
         .catch((error) => {
           checkError(error.response.status);
           reject(error.response);
         });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
